module["exports"] = ["ديزل", "كهربائي", "بنزين", "هجين"];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/vehicle/fuel.js
// module id = 2397
// module chunks = 1610